import { ThemeLibrary as CngThemeLibrary } from 'cng-web-lib'
import upsColorConfiguration from 'src/theme/upsColorConfiguration'
import defaultTheme from 'src/assets/defaultTheme.js'
import modernBlueTheme from 'src/assets/modernBlueTheme'
import modernRedTheme from 'src/assets/modernRedTheme'

class ThemeLibrary extends CngThemeLibrary {

  constructor(names, configurations) {
    super()

    if (names) {
      this._names = names
    } else {
      this._names = ['MODERN_BLUE', 'MODERN_RED', ...super.getNames()]
    }

    if (configurations) {
      this._configurations = configurations
    } else {
      if (window.location.pathname.includes('/ups')) {
        this._configurations = super.getConfigurations(upsColorConfiguration)
      } else {
        this._configurations = [modernBlueTheme, modernRedTheme, ...defaultTheme]
      }
    }
  }

  getNames() {
    return this._names
  }

  getConfigurations() {
    return this._configurations
  }
}

export default ThemeLibrary
